import React from "react";
import { Info } from "lucide-react";
import { CONDITIONS, normalizeCondition } from "@/lib/marketplace";

export default function ConditionPicker({ value, onChange, testIdPrefix = "condition", className = "" }) {
  const selected = normalizeCondition(value);
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid={`${testIdPrefix}-picker`}>
      {CONDITIONS.map((option) => {
        const picked = selected === option.value;
        return (
          <div key={option.value} className="group relative">
            <button
              type="button"
              onClick={() => onChange(option.value)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-bold transition ${
                picked
                  ? "border-brandPink bg-brandPink text-white"
                  : "border-slate-200 bg-white text-slate-700 hover:border-brandPink hover:text-brandPink"
              }`}
              data-testid={`${testIdPrefix}-${option.value}`}
              aria-pressed={picked}
              aria-describedby={`${testIdPrefix}-tooltip-${option.value}`}
            >
              {option.label}
              <Info className="h-3.5 w-3.5 opacity-75" aria-hidden="true" />
            </button>
            <div
              id={`${testIdPrefix}-tooltip-${option.value}`}
              role="tooltip"
              className="pointer-events-none absolute left-0 top-full z-30 mt-2 hidden w-64 rounded-xl border border-slate-200 bg-white p-3 text-xs font-medium leading-relaxed text-slate-600 shadow-xl group-hover:block group-focus-within:block"
              data-testid={`${testIdPrefix}-tooltip-${option.value}`}
            >
              {option.tooltip}
            </div>
          </div>
        );
      })}
    </div>
  );
}
